import { render, staticRenderFns } from "./ButtonGroupComponent.vue?vue&type=template&id=6a5a0e20&scoped=true&"
import script from "./ButtonGroupComponent.vue?vue&type=script&lang=ts&"
export * from "./ButtonGroupComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonGroupComponent.vue?vue&type=style&index=0&id=6a5a0e20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5a0e20",
  null
  
)

export default component.exports